import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/shareholderDocuments');

export default function shareholderDocumentsHint() {
  return <Content />;
}
